export let PackagePickerType = /*#__PURE__*/function (PackagePickerType) {
  PackagePickerType["Default"] = "default";
  PackagePickerType["EditorX"] = "editorx";
  PackagePickerType["Dayful"] = "dayful";
  PackagePickerType["Studio"] = "studio";
  PackagePickerType["Sunrise"] = "sunrise";
  PackagePickerType["Sandbox"] = "sandbox";
  PackagePickerType["EditorXToStudio"] = "editorx_to_studio";
  PackagePickerType["GoogleVoice"] = "google_voice";
  PackagePickerType["SocialMediaMarketing"] = "social_media_marketing";
  PackagePickerType["Gemini"] = "gemini";
  PackagePickerType["BusinessEmail"] = "business_email";
  PackagePickerType["EmailMarketing"] = "email_marketing";
  PackagePickerType["AiChat"] = "ai_chat";
  return PackagePickerType;
}({});
export let PurchaseModeV2 = /*#__PURE__*/function (PurchaseModeV2) {
  PurchaseModeV2["InitialPurchase"] = "initialPurchase";
  PurchaseModeV2["SecondUpgrade"] = "secondUpgrade";
  PurchaseModeV2["ChangePlan"] = "changePlan";
  PurchaseModeV2["Anonymous"] = "anonymous";
  PurchaseModeV2["Unauthorized"] = "Unauthorized";
  return PurchaseModeV2;
}({});
export let SaleMode = /*#__PURE__*/function (SaleMode) {
  SaleMode["SeasonalSale"] = "SeasonalSale";
  SaleMode["PersonalSale"] = "PersonalSale";
  SaleMode["SeasonalExtended"] = "SeasonalExtended";
  SaleMode["SpecialDiscount"] = "SpecialDiscount";
  SaleMode["None"] = "None";
  return SaleMode;
}({});
//# sourceMappingURL=app-modes.js.map